import axios from "axios";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import LanguageModal from "./Model/LanguageModal";

function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const inputRef = useRef(null);

 const [socialLinks, setSocialLinks] = useState({});
 const [currency, setCurrency] = useState({
  id: "",
  country_name: "",
  currency: "",
  symbol: "",
});
 const [languageOpen, setLanguageOpen] = useState(false);
const date = new Date();

  // ✅ Fetch social/contact data on mount
  useEffect(() => {
    fetchContactData();
  }, []);

  const fetchContactData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getContactUsContent`,
      );
      if (res.data?.status) {
        setSocialLinks(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching contact data:", error);
    }
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email.");
      if (inputRef.current) {
        inputRef.current.focus(); // Focus input on error
      }
      return;
    }

    try {
      setLoading(true);
      setMessage("");

      const response = await toast.promise(
        axios.post(`${process.env.REACT_APP_API_BASE}/subscribe-now`, {
          email: email,
        }),
        {
          loading: "Subscribing...",
           success: (res) => res.data?.message || "You're now subscribed to Weyfarin! Enjoy exclusive updates, offers, and experiences.",
        },
      );

      if (response.data?.status) {
        // toast.success("✅ Subscribed successfully!");
        setEmail("");
        if (inputRef.current) {
          inputRef.current.focus(); // Focus again after clear
        }
      } else {
      }
    } catch (error) {
      console.error("Subscribe Error:", error);
      const errMsg =
        error.response?.data?.message ||
        "Failed to subscribe. Please try again.";
      toast.error(errMsg);
      if (inputRef.current) {
        inputRef.current.focus();
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchCurrencyById = async (currencyId) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getCurrencyByCountry`,
        {
          params: { currency_id: currencyId },
        },
      );

      if (res.data?.status) {
        setCurrency(res.data.data);

        // Trigger global update
        window.dispatchEvent(new Event("currency-changed"));
      }
    } catch (error) {
      console.error("Error fetching currency by ID:", error);
    }
  };

  useEffect(() => {
    const selected = JSON.parse(localStorage.getItem("selectedCurrency"));

    if (selected?.id) {
      // setCurrency(selected);
      fetchCurrencyById(selected.id); // <-- API call ONLY on first load
    }
  }, []);

  // useEffect(() => {
  //   const update = () => {
  //     const updated = JSON.parse(localStorage.getItem("selectedCurrency"));
  //     if (updated) setCurrency(updated);
  //   };

  //   window.addEventListener("currency-changed", update);

  //   return () => window.removeEventListener("currency-changed", update);
  // }, []);

  useEffect(() => {
    const checkCurrencyChange = () => {
      const stored = JSON.parse(localStorage.getItem("selectedCurrency"));
      if (stored?.id && String(stored.id) !== String(currency.id)) {
        fetchCurrencyById(stored.id); // 🔥 Har ID change par API call
      }
    };

    // Listen for cross-tab updates
    window.addEventListener("storage", checkCurrencyChange);

    // Every 1 sec check (same tab change)
    const interval = setInterval(checkCurrencyChange, 1000);

    return () => {
      window.removeEventListener("storage", checkCurrencyChange);
      clearInterval(interval);
    };
  }, [currency.id]);

  return (
    <footer id="Footer_arae">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-sm-4">
            <div class="ftr_partss adss_flss">
              <h4 class="lgo_mbss">
                <img src="/images/ftr_logo.png" alt="Weyfarin" />
              </h4>
              <ul class="lgo_artss">
                <li>For inquiry and assistance</li>
                <li>
                  <Link to={"contactus"}>Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-3 col-sm-4">
            <div class="ftr_partss">
              <h4>About Us</h4>
              <ul>
                {/*<li>
                  <Link to={'help-and-faq'}>Help Center</Link>
                </li> */}
                <li>
                  <Link to={"about"}> About Weyfarin</Link>
                </li>
                <li>
                  <Link to={"contactus"}>Contact us </Link>
                </li>
                {/* <li>
                  <Link to={'job-opening'}>Careers </Link>
                </li> */}
                <li>
                  <Link to={"help-and-faq"}>Help Center/FAQ </Link>
                </li>
                <li>
                  <Link to={"blogs"}>Blogs</Link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-3 col-sm-4">
            <div class="ftr_partss">
              <h4>Useful Links</h4>
              <ul>
                {/*<li>
                  <Link to={'site-map'}>SiteMap</Link>
                </li> */}
                <li>
                  <Link to={"term-service"}>Terms And Condition</Link>
                </li>
                <li>
                  <Link to={"privacy-policy"}>Privacy Policy</Link>
                </li>
                <li>
                  <Link to={"/cancellation"}>Cancellation Policy</Link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-3 col-sm-6">
            <div class="ftr_partss subscrib">
              <h4>Subscribe Our Newsletter</h4>
              <p>
                Subscribe our newsletter to get all the latest updates from us
              </p>
              <div className="src_bothss">
                {/* <input type="text" placeholder="Enter your email " value="" />
			   <button type="submit" value=""><img src="/images/w_arrow_trangal.png" alt="" /></button> */}
                <form className="src_bothss" onSubmit={handleSubscribe}>
                  <input
                    ref={inputRef}
                    type="email"
                    placeholder="Enter your email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button type="submit" disabled={loading}>
                    {loading ? (
                      <span className="spinner srcc"></span>
                    ) : (
                      <img src="/images/w_arrow_trangal.png" alt="send" />
                    )}
                  </button>
                </form>
              </div>
              {message && (
                <p style={{ fontSize: "14px", marginTop: "8px" }}>{message}</p>
              )}
            </div>

            <div class="ftr_partss">
              <h4>Social Media </h4>
              {/* <ul className="socialsse">
			   <li><Link to={'https://www.instagram.com/weyfarin/?igsh=MXcwdjlhYXFpbW5pdg%3D%3D#'} target="_blank" rel="noopener noreferrer" ><img src="/images/instagr_ic.png" alt="Instagram" /></Link></li>
			   <li><Link to={'https://www.facebook.com/profile.php?id=61578282492671&mibextid=wwXIfr&rdid=tA7e0iVzWBBkPvcy&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DfcwMXUgq%2F%3Fmibextid%3DwwXIfr#'} target="_blank" rel="noopener noreferrer"><img src="/images/facebooks_ic.png" alt="Facebook" /></Link></li>
			   <li><Link to={' https://www.tiktok.com/@weyfarin?_r=1&_t=ZS-913ldcRceA6'} target="_blank" rel="noopener noreferrer"><img src="/images/tiktok.png" alt="TikTok" /></Link></li>
			  </ul>  */}

              <ul className="socialsse">
                {socialLinks.instagram && (
                  <li>
                    <a
                      href={socialLinks.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/instagr_ic.png" alt="Instagram" />
                    </a>
                  </li>
                )}
                {socialLinks.facebook && (
                  <li>
                    <a
                      href={socialLinks.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/facebooks_ic.png" alt="Facebook" />
                    </a>
                  </li>
                )}
                {socialLinks.tiktok && (
                  <li>
                    <a
                      href={socialLinks.tiktok}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/tiktok.png" alt="TikTok" />
                    </a>
                  </li>
                )}
                {socialLinks.youtube && (
                  <li>
                    <a
                      href={socialLinks.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/youtube_ic.png" alt="YouTube" />
                    </a>
                  </li>
                )}
                {socialLinks.linkedin && (
                  <li>
                    <a
                      href={socialLinks.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/linkedin_ic.png" alt="LinkedIn" />
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        <div class="eml_socilal">
          <div class="em_ico">
            Copyright © {date.getFullYear()}{" "} <a href="https://www.weyfarin.com/">www.weyfarin.com</a> All Rights Reserved.&nbsp;{" "}
            <Link to={'privacy-policy'}>Privacy</Link>&nbsp;·{" "}
            <Link to={'term-service'}>Terms</Link>&nbsp;·{" "}
            <Link to={'site-map'}>Sitemap</Link>
          </div>
          <div class="social mb_view_hide">
            <div class="socialss">
              <Link onClick={() => setLanguageOpen(true)}>
                🌐 English ({currency?.currency || "AUD"})
              </Link>

              <Link onClick={() => setLanguageOpen(true)}>
                {currency?.symbol && currency?.currency
                  ? `${currency.symbol} ${currency.currency}`
                  : "$ AUD"}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <LanguageModal
        isOpen={languageOpen}
        onClose={() => setLanguageOpen(false)}
      />
    </footer>
  );
}

export default Footer;
